import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import AboutBook from "@/pages/AboutBook";
import AboutAuthor from "@/pages/AboutAuthor";
import Network from "@/pages/Network";
import Enterprises from "@/pages/Enterprises";
import Ecosystem from "@/pages/Ecosystem";
import Apply from "@/pages/Apply";
import Blog from "@/pages/Blog";
import Newsletter from "@/pages/Newsletter";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";
import ProtectedRoute from "@/components/ProtectedRoute";
import Analytics from "@/components/Analytics";
import { AuthProvider } from "@/context/AuthContext";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
}

function PublicLayout({ children }) {
    return (
        <>
            <Navbar />
            {children}
            <Footer />
        </>
    );
}

export default function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Analytics />
                    <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#111111", border: "1px solid #2A2A2A", color: "#F9FAFB" } }} />
                    <Routes>
                        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                        <Route path="/book" element={<PublicLayout><AboutBook /></PublicLayout>} />
                        <Route path="/about" element={<PublicLayout><AboutAuthor /></PublicLayout>} />
                        <Route path="/author" element={<Navigate to="/about" replace />} />
                        <Route path="/network" element={<PublicLayout><Network /></PublicLayout>} />
                        <Route path="/directory" element={<PublicLayout><Enterprises /></PublicLayout>} />
                        <Route path="/founders" element={<Navigate to="/directory" replace />} />
                        <Route path="/featured" element={<Navigate to="/directory" replace />} />
                        <Route path="/enterprises" element={<Navigate to="/directory" replace />} />
                        <Route path="/ecosystem" element={<PublicLayout><Ecosystem /></PublicLayout>} />
                        <Route path="/apply" element={<PublicLayout><Apply /></PublicLayout>} />
                        <Route path="/ecosystem/apply" element={<Navigate to="/apply" replace />} />
                        <Route path="/founder-stories" element={<PublicLayout><Blog /></PublicLayout>} />
                        <Route path="/blog" element={<Navigate to="/founder-stories" replace />} />
                        <Route path="/conversations" element={<Navigate to="/founder-stories" replace />} />
                        <Route path="/join" element={<PublicLayout><Newsletter /></PublicLayout>} />
                        <Route path="/newsletter" element={<Navigate to="/join" replace />} />
                        <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                        <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}
